import Navbar1 from "./Components/Navbar.js"
import Background from "./Components/background-image.js"
import Section1 from "./Components/section1.js"
import Section2 from "./Components/section2.js"
import Section3 from "./Components/section3.js"
import Section4 from "./Components/section4.js"
import Section5 from "./Components/section5.js"
import Section6 from "./Components/section6.js"
import Section7 from "./Components/section7.js"
import Section8 from "./Components/section8.js"
import Section9 from "./Components/section9.js"
import Section10 from "./Components/section10.js"
import Section11 from "./Components/section11.js"
import Section12 from "./Components/section12.js"
import Footer from "./Components/footer.js";
function App() {
  return (
    <>
    <Navbar1/>
 <Background/>
    <Section1/>
    <Section2/>
    <Section3/>
    <Section4/>
    <Section5/>
    <Section6/>
    <Section7/>
    <Section8/>
    <Section9/>
    <Section10/>
    <Section11/>
    <Section12/>
    <Footer/>
 </>
  );
}

export default App;
